<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="start">
    <mat-horizontal-stepper [linear]="true" class="pt-16" labelPosition="bottom" #stepper>
        <mat-step *ngIf="showFirstStep" [completed]="!!selectedUsersList.length">
            <ng-template matStepLabel>{{ 'GENERAL.LABEL.PARTICIPANTS' | translate }}</ng-template>

            <ng-container *ngIf="selectedUsersList.length">
                <h3 class="mb-8 text-base font-medium text-gray-600">{{ 'GENERAL.LABEL.SELECTED_USERS' | translate }}</h3>
                <mat-chip-set class="chip-list wrap">
                    <mat-chip class="chip maxbrain-500" [removable]="removable" (removed)="removeFromList(user)" *ngFor="let user of selectedUsersList">
                        {{ user.fullName }}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-set>
            </ng-container>

            <div fxLayout="row" fxLayoutAlign="flex-end center" class="mb-12">
                <app-search-outline [searchInput]="searchInput"></app-search-outline>
            </div>

            <div class="w-100-p table-wrapper" *ngIf="dataSource">
                <mat-table #table [dataSource]="dataSource" matSort>
                    <!-- Avatar Column -->
                    <ng-container matColumnDef="avatar">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let moduleUser">
                            <div class="relative" #avatarCell>
                                <img class="avatar" *ngIf="moduleUser.user?.avatar.src; else initials" [alt]="moduleUser.user.fullName" [src]="moduleUser.user.avatar.src" />
                                <ng-template #initials>
                                    <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ moduleUser.user.fullName | initials }}</div>
                                </ng-template>
                                <ng-template [onlineStateIndicator]="moduleUser.user.isOnline"> </ng-template>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <!-- First Name Column -->
                    <ng-container matColumnDef="firstName">
                        <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header> {{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let moduleUser" class="narrow">
                            <p #firstNameRow class="text-truncate font-semibold">
                                {{ moduleUser.user.firstName }}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <!-- Last Name Column -->
                    <ng-container matColumnDef="lastName">
                        <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header>
                            {{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let moduleUser" class="narrow">
                            <p #lastNameRow class="text-truncate font-semibold">
                                {{ moduleUser.user.lastName }}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <!-- Email Column -->
                    <ng-container matColumnDef="email">
                        <mat-header-cell class="wider" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                            {{ 'GENERAL.PROPERTY.EMAIL' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let moduleUser" fxHide fxShow.gt-xs>
                            <p #lastNameRow class="text-truncate font-semibold">{{ moduleUser.user.email }}</p>
                        </mat-cell>
                    </ng-container>

                    <!-- Buttons Column -->
                    <ng-container matColumnDef="buttons">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let moduleUser">
                            <div fxFlex="row" fxLayoutAlign="end center">
                                <app-flat-button
                                    [label]="'GENERAL.BUTTON.ADD'"
                                    (onClick)="addToList(moduleUser.user)"
                                    *ngIf="!moduleUser.alreadyMember && !moduleUser.selected"
                                ></app-flat-button>
                                <p *ngIf="moduleUser.user.alreadyMember">{{ 'GENERAL.LABEL.IN_GROUP' | translate }}</p>
                                <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(moduleUser.user)" *ngIf="moduleUser.selected"></app-white-button>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let moduleUser; columns: displayedColumns" matRipple> </mat-row>
                </mat-table>
                <mat-paginator persistPageSize="course-offering-participants.add-bookings-dialog" [length]="totalCount$ | async" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 50]"> </mat-paginator>
            </div>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel> {{ 'GENERAL.LABEL.EXECUTIONS' | translate }}</ng-template>

            <mat-form-field class="w-100-p">
                <mat-label>{{ 'GENERAL.LABEL.EXECUTION' | translate }}</mat-label>
                <mat-select [formControl]="selectedExecution" [panelClass]="'add-bookings-execution-panel'">
                    <mat-option *ngFor="let execution of executions" [value]="execution" [disabled]="!isExecutionSelectable(execution)">
                        <div
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            class="execution-option-row"
                            [class.execution-option-disabled]="!isExecutionSelectable(execution)"
                        >
                            <div fxLayout="column" fxLayoutAlign="start start" class="execution-option-main">
                                <span class="execution-option-name">
                                    {{ execution.name }}
                                </span>
                                <span class="execution-option-meta text-xs">
                                    ({{
                                        execution.version
                                            ? execution.version
                                            : execution.startDate
                                            ? (execution.startDate | date: 'shortDate') + ' - ' + (execution.endDate | date: 'shortDate')
                                            : '-'
                                    }})
                                </span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="end center" class="execution-option-tags text-sm">
                                <span *ngIf="getDisabledExecutionSuffixLabel(execution)" class="execution-option-status mr-8 whitespace-nowrap">
                                    {{ getDisabledExecutionSuffixLabel(execution) | translate }}
                                </span>
                                <span
                                    *ngIf="execution.isDefault"
                                    class="execution-option-default bg-primary-50 rounded-full px-16 py-8 text-sm text-primary-600 font-medium whitespace-nowrap"
                                >
                                    {{ 'PAGE.DIALOG.EDIT_RELEVANT_EXECUTIONS.LABEL.DEFAULT_EXECUTION' | translate }}
                                </span>
                            </div>
                        </div>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-step>

        <mat-step [completed]="false">
            <ng-template matStepLabel>{{ 'GENERAL.LABEL.NOTIFICATION' | translate }}</ng-template>

            <mat-checkbox [(ngModel)]="notifyMembers">{{ 'GENERAL.BUTTON.SEND_NOTIFICATION' | translate }}</mat-checkbox>
        </mat-step>
    </mat-horizontal-stepper>
</div>

<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button
        [label]="'GENERAL.BUTTON.NEXT'"
        class="mr-8"
        [disabled]="showFirstStep && stepper?.selectedIndex === 0 ? !selectedUsersList.length : !canGoToNotificationStep"
        (onClick)="goForward(stepper)"
        *ngIf="shouldShowNextButton"
    ></app-flat-button>

    <app-flat-button
        [label]="
            selectedUsersList.length ? ('GENERAL.BUTTON.BOOK_PARTICIPANTS' | translate: { participantsCount: selectedUsersList.length }) : 'GENERAL.BUTTON.BOOK_ALL_PARTICIPANTS'
        "
        [disabled]="!selectedExecution.value"
        (onClick)="saveSelected()"
        *ngIf="isLastStep"
    ></app-flat-button>
</div>
